import React, {useContext, useEffect, useState} from 'react';
import { FaRegEye } from "react-icons/fa";
import Gallery from "./Gallery";
import fetchImagesFromFolder from "../functions/fetchImagesFromFolder";
import {LanguageContext} from "../languages/LanguageContext";

const GalleryPreview = ({
    folder,
    imageCount,
    prefix,
    news,
    suffix
}) => {
    const { language, translations } = useContext(LanguageContext);
    const [ gallery, setGallery ] = useState(false);
    const [ images, setImages ] = useState([]);
    useEffect(() => {
        if(folder && imageCount && prefix) {
            setImages(fetchImagesFromFolder(folder, imageCount, prefix, suffix, "jpg"));
        }
    }, [folder, imageCount, prefix, setImages, suffix]);
    return (
        <>
            <div className={news ? 'gallery-preview news-preview' : 'gallery-preview'}>
                <button onClick={() => setGallery(true)}><FaRegEye className='iconz' alt='Click to view image gallery'/>{translations[language]["viewImages"]}</button>
                { images.length > 8 &&
                    images.slice(0, 7).map((image, index) => (
                        <div className='image-preview-box'>
                            <img src={image} alt={'accommodation' + index} key={index}/>
                        </div>
                    ))
                }
                {images.length < 7 &&
                    images.map((image, index) => (
                        <div className='image-preview-box'>
                            <img src={image} alt={'accommodation' + index} key={index}/>
                        </div>
                    ))
                }
            </div>
            {images.length > 1 &&
                <Gallery
                    gallery={gallery}
                    setGallery={setGallery}
                    images={images}
                />
            }
        </>
    );
};

export default GalleryPreview;